import dt from "zmfront-framework/src/utils/dateService";

const zmFormula = {};
zmFormula.formulaStr=null;


zmFormula.zmformulahelper = function (str){
    //.replace(new RegExp("ceil","gm"), "Math.ceil")
    return  zmFormula.formulaStr = str
        .replace(new RegExp("and","gm"), "&&")
        .replace(new RegExp("\\sor\\s","gm"), "||")
        .replace(new RegExp("not","gm"),"!")
        .replace(new RegExp("else","gm"),"}\nelse\n{")
        .replace(new RegExp("case\\swhen","gm"), "if (")
        .replace(new RegExp("then","gm"),"){")
        .replace(new RegExp("when","gm"), "}\nelse if (")
        .replace(new RegExp("end","gm"),"}");
};
function ceiling(str1) {
    if (str1 < 0)
        return 0;
    else
        return Math.ceil(str1);
};

zmFormula.money =function moneyFormat(money){
    // 如果为空
    if (!money ) {
        return "0.00";
    }
    //没有小数补齐这个0
    if(money.indexOf(".")=="-1"){
        money=money+".00";
    }else{
        //有小数截取前二位小数
        money=money.substring(0,money.indexOf(".")+3);
    }
    return money
}
function round(str) {
    return Math.round(str)
};
function floor(str){
    return Math.floor(str)
};
//返回计算值
zmFormula.evalOfBigDecimal = function (){
    return eval(zmFormula.formulaStr);
};
//判断是否执行成功
zmFormula.checkFormula = function (){
    try {
        eval(zmFormula.formulaStr);
    }catch (err) {
        return false;
    }
    return true;
};
//替换
zmFormula.setParam= function (key, value){
    let fee=zmFormula.formulaStr;
    zmFormula.formulaStr=fee.replace(new RegExp(key,"gm"),value);
};
//离现在多少年  nian年份 可以正负
zmFormula.currentDateLater=function (nian) {
    var date = new Date();
    var y = date.getFullYear() + nian;
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if(m<10){
        m='0'+m;
    }
    // var h = date.getHours();//获取当前小时
    // var minute = date.getMinutes();//获取当前分钟
    // var second = date.getSeconds();//获取当前秒
    // minute = minute < 10 ? ('1' + minute) : minute;
    // second = second < 10 ? ('0' + second) : second;
    let dateString= y + '-' + m + '-' + d + ' ' + 23 + ':' + 59 + ':' + 59;
    if (dateString) {
        var arr1 = dateString.split(" ");
        var sdate = arr1[0].split('-');
        var date = new Date(sdate[0], sdate[1]-1, sdate[2],23,59,59);
        return date;
    }
}
//离现在多少年  nian年份 可以正负
zmFormula.currentDateLaterStr=function (nian) {
    var date = new Date();
    var y = date.getFullYear() + nian;
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if(m<10){
        m='0'+m;
    }
    if(d<10){
        d='0'+d;
    }
    let dateString= y + '-' + m + '-' + d + ' ' + 23 + ':' + 59 + ':' + 59;
   return dateString;
}

zmFormula.dateFrom=function (jy) {
    var date = new Date();
    var sgydyt="";
    var nain=date.getFullYear();
    var yue=date.getMonth()+1;
    if(!jy){
        jy=0;
    }
    if(yue-jy<=0){
        nain=nain-1;
        yue=(date.getMonth()+14)-jy;
    }else{
        yue=(date.getMonth()+2)-jy;
    }
    if(yue>=10){
        sgydyt=nain+"-"+yue+"-"+"01";
    }else{
        sgydyt=nain+"-0"+yue+"-"+"01";
    }
    return sgydyt;
}

zmFormula.monthDates=function (yue) {
    var date = new Date();
    var month=((date.getMonth()+1) - yue);
    var year=date.getFullYear();
    if(((date.getMonth()+1)-yue)<=0){
        year=date.getFullYear()-1;
        month=(date.getMonth()+13) - yue;
    }else{
        month=((date.getMonth()+1) - yue);
    }
    var befD ='';
    var dateTime='';
    if(date.getDate()>=10){
        dateTime=date.getDate()+"";
    }else{
        dateTime='0'+date.getDate();
    }
    if(month>=10){
        befD = year + "-" + (month) + "-" +dateTime+" 00:00:00";
    }else{
        befD = year + "-0" + (month) + "-" +dateTime+" 00:00:00";
    }
    console.log(befD);
    return befD;
}

export default zmFormula;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmFormulaHelperService.js